import { WeightUnit } from "@redotech/cockroachdb-codegen/tables/product/weight-unit";
import * as z from "zod";

export const getOmsApparelMagicIntegration = {
  name: "getOmsApparelMagicIntegration" as const,
  input: z.object({}),
  output: z.object({
    exists: z.boolean(),
    enabled: z.boolean().optional(),
    usePickTicketNumberAsOrderName: z.boolean().optional(),
    autoInvoicePickTickets: z.boolean().optional(),
    defaultWeightUnit: z.enum(WeightUnit).optional(),
  }),
};
